<template>
	<Loader v-if="loading" />
	<div v-else class="tags">

		<div
			class="tag"
			v-on:click="toggle(tag)"
			v-for="tag in getTags"
			v-bind:class="{
				active: isTagged(tag),
			}">
				{{ tag.tag }}
		</div>

	</div>
</template>

<style lang="less" scoped>
	.tags {
		.tag {
			cursor: pointer;
			&.active {
				background: #2f3239;
				color: #fff;
			}
		}
	}
</style>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    data: []
  }),
  computed: {
    ...mapGetters([
      'getTags'
    ])
  },
  methods: {
    isTagged (tag) {
      for (var t of this.data) {
        if (t.tag_id === tag.id) {
          return true
        }
      }

      return false
    },
    toggle (tag) {
      if (this.id === undefined) {
        this.toggleTagCreation(tag)
      } else {
        this.toggleTagEdit(tag)
      }
    },
    toggleTagCreation (tag) {
      if (this.isTagged(tag)) {
        this.data.splice(
          this.data.findIndex(row => row.tag_id === tag.id),
          1
        )
      } else {
        this.data.push({ tag_id: tag.id })
      }
      this.$emit('tag-selected', this.data)
    },
    toggleTagEdit (tag) {
      if (this.isTagged(tag)) {
        Vue.$api.delete('/product/' + this.id + '/tag/' + tag.id, {}, {
          loader: toggle => this.loading = toggle,
          callback: () => this.load()
        })
      } else {
        Vue.$api.post('/product/' + this.id + '/tag/' + tag.id, {}, {
          loader: toggle => this.loading = toggle,
          callback: () => this.load()
        })
      }
    },
    load () {
      if (this.id !== undefined) {
        Vue.$api.get('/product/' + this.id + '/tags', {}, {
          loader: toggle => this.loading = toggle,
          callback: data => this.data = data
        })
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
